import type { URLAndS3Object } from "@/lib/aws-amplify/storage";
import type { S3Object } from "@/lib/gql/__generated__/graphql";

export const DUMMY_IMAGE: URLAndS3Object = {
	url: "https://prd-assets.chillnn.com/public/assets/CHILLNN_LOADING.jpg",
	s3Object: {
		bucket: "prd-chillnn-gamma-host-bucket",
		fileName: "CHILLNN_LOADING.jpg",
		key: "public/assets/CHILLNN_LOADING.jpg",
		mimeType: "image/jpeg",
		region: "ap-northeast-1",
	} satisfies S3Object,
} satisfies URLAndS3Object;
